export default "__VITE_ASSET__BxdZ$0ag__"